import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiBaseUrlService } from './api-base-url.service';

@Injectable({
  providedIn: 'root',
})
export class NodeApiCallService {
  headers: HttpHeaders;

  constructor(
    private http: HttpClient,
    private apiBaseUrlService: ApiBaseUrlService
  ) {
    this.headers = new HttpHeaders();
  }

  private setCustomHeader(headers: any) {
    const headersArray = headers ? headers : {};
    if (Object.keys(headersArray).filter((x) => x == 'Content-Type').length <= 0) {
      headersArray['Content-Type'] = 'application/json';
    }
    this.headers = new HttpHeaders(headersArray);
  }

  public Post(url: string, params: any, headers?: any, responseType?: any): Observable<any> {
    this.setCustomHeader(headers);
    if (!this.headers.has('X-Portal')) {
      this.headers = this.headers.set('X-Portal', 'frontend');
    }
    return this.http.post(this.apiBaseUrlService.getNodeBaseUrl() + url, params, {
      headers: this.headers,
      responseType: responseType ?? 'json',
    });
  }
}
